import styled from 'styled-components';
import { getSpacingToken, Sized } from '@optimus-web/common';

export const ContainerElement = styled.div<Sized>`
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 ${(props) => getSpacingToken(props.size === 'small' ? '100' : '200')}px;

    input {
        text-align: center;
        box-sizing: border-box;
    }
`;

export const FlexInputContainer = styled.div`
    flex: 1;
`;

export const CounterButtonWrapper = styled.span<{ disabled?: boolean }>`
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};
    display: flex;
`;
